import React from "react";

import Typography from "@mui/material/Typography";

import * as IntegrationUtils from "@app/analytics/Integrations/utils";
import ROUTES from "@app/common/routes";

import { Link } from "@rui/Link";
import { Bold } from "@rui/styles";

const DistributionSettingPreview = ({
  settingName,
  recipients,
  integrationDisplayName,
}: {
  settingName: string;
  recipients: string;
  integrationDisplayName: string;
}) => {
  if (!recipients) return null;

  return (
    <li>
      Read will automatically send {settingName} to <Bold>{recipients}</Bold>{" "}
      via {integrationDisplayName} (
      <Link to={ROUTES.USER_SETTINGS_REPORTING} fontWeight={400}>
        Manage
      </Link>
      )
      {IntegrationUtils.shouldShowParticipantDisclaimer(recipients) && (
        <>
          <br />
          <Typography variant="labelReg" color="shades.neutral.500">
            *Only applies to participants who are members of your{" "}
            {integrationDisplayName} Workspace.
          </Typography>
        </>
      )}
    </li>
  );
};

export default DistributionSettingPreview;
